module.exports = function() {
  return new Worker(__webpack_public_path__ + "0578464ad93ff8484e10.worker.js");
};